import {openForethoughtAIChatbot} from "../../../../scripts/global/forethought-integration.util.js";

(function (TSUtils) {

    "use strict";
    angular
        .module('harriApp')
        .directive('tsHeaderOne', ['$q', '$rootScope', 'reportsPrerequisiteService', '$timeout', '$state', '$stateParams', 'hUser', 'TSSideBarService', 'TeamCommunicationService', 'TSUsersService', 'TeamScheduleService', 'deviceChecker', 'userServices', 'userPermissions', 'barriAnalyticsService', 'commshubService', 'headerItemsService', '$modal', 'brandServices', 'TLEmployerSettingsDataService', 'dashboardsPrerequisiteService', 'versionManager', 'localize',
            function ($q, $rootScope, reportsPrerequisiteService, $timeout, $state, $stateParams, hUser, TSSideBarService, TeamCommunicationService, TSUsersService, TeamScheduleService, deviceChecker, userServices, userPermissions, barriAnalyticsService, commshubService, headerItemsService, $modal, brandServices, TLEmployerSettingsDataService, dashboardsPrerequisiteService, versionManager, localize) {
                return {
                    restrict: 'E',
                    replace: true,
                    templateUrl: "../modules/team_schedule/common/views/ts_header_one_directive.html",
                    scope: {},
                    link: function (scope, element, attrs) {
                        var moreLinkWidth = 0;
                        var navBarPreference = [];

                        scope.isSettingsTabShown = false;
                        scope.employeeBusinesses = [];
                        let canViewCompaasDashboard = false;
                        let canViewRiskDashboard = false;

                        var allHeaderItems = [
                            {
                                key: 'TEAM',
                                automation: 'teamHeader',
                                label: $filter("translate")('Team'),
                                click: function () {
                                    return scope.goToTeam();
                                },
                                isVisible: true,
                                checkVisibility: function () {
                                    return true;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.core-hr.list' &&
                                           $stateParams['source'] === 'TL';
                                }
                            },
                            {
                                key: 'TEAM_CHECK',
                                automation: 'teamCheckLink',
                                label: $filter("translate")('Team Check'),
                                uiSref: {
                                    name: 'appLayout.schedule.team-health-check'
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isTeamQuestionnaireServiceEnabled && scope.canManageEmployeeQuestionnaire;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState().indexOf('appLayout.schedule.team-health-check') !== -1;
                                }
                            },
                            {
                                key: 'COMMSHUB',
                                label: $filter("translate")('CommsHub'),
                                click: function () {
                                    return scope.goToCommunicationHub();
                                },
                                rel: 'nofollow',
                                isVisible: false,
                                automation: 'tsHeaderCommshubLink',
                                checkVisibility: function () {
                                    return (scope.isEmployer && scope.isCommsHubServiceEnabled) || (!scope.isEmployer && scope.employeeHaveCommsHub);
                                },
                                getBadge: function () {
                                    if (scope.unseenMessagesCount) {
                                        if (scope.unseenMessagesCount > 99) {
                                            return '99+';
                                        } else {
                                            return scope.unseenMessagesCount
                                        }
                                    } else {
                                        return null;
                                    }
                                }
                            },
                            {
                                key: 'LOGBOOK_MENU',
                                label: $filter("translate")('Logbook'),
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isLogbookEnabled;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState().indexOf('appLayout.schedule.logbook.') !== -1;
                                },
                                subItems: [
                                    {
                                        key: 'ENTRIES',
                                        label: $filter("translate")('Entries'),
                                        uiSref: {
                                            name: 'appLayout.schedule.logbook.logbook-entries'
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return scope.canViewLogbookEntries;
                                        }
                                    },
                                    {
                                        key: 'CHECKLISTS',
                                        label: $filter("translate")('Checklists'),
                                        uiSref: {
                                            name: 'appLayout.schedule.logbook.logbook-checklists'
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return scope.canViewChecklists;
                                        }
                                    },
                                    {
                                        key: 'TASKS',
                                        label: $filter("translate")('Tasks'),
                                        uiSref: {
                                            name: 'appLayout.schedule.logbook.logbook-team-tasks',
                                            options: {
                                                inherit: false
                                            }
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return scope.canViewTasks;
                                        }
                                    }
                                ]
                            },
                            {
                                key: 'SCHEDULE',
                                label: $filter("translate")('Schedule'),
                                click: function () {
                                    return scope.goToSchedule();
                                },
                                automation: 'teamHeaderScheduleLink',
                                isVisible: false,
                                checkVisibility: function () {
                                    return (!scope.approvalWorkflowEnabled || !scope.canApproveAndPublishSchedule) && !scope.isRegularScheduleVariationsEnabled;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.main';
                                },
                            },
                            {
                                key: 'SCHEDULING',
                                label: $filter("translate")('Scheduling'),
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isEmployer && (scope.approvalWorkflowEnabled && scope.canApproveAndPublishSchedule) || scope.isRegularScheduleVariationsEnabled ;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return ['appLayout.schedule.main', 'appLayout.schedule.schedule-dash', 'appLayout.schedule.regular-schedule-variations'].indexOf(scope.getCurrentState()) > -1;
                                },
                                subItems: [
                                    {
                                        key: 'SCHEDULE_SUB',
                                        label: $filter("translate")('Schedule'),
                                        uiSref: {
                                            name: 'appLayout.schedule.main'
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return true;
                                        },
                                    },
                                    {
                                        key: 'SCHEDULE_DASH',
                                        label: $filter("translate")('Schedule Dash'),
                                        uiSref: {
                                            name: 'appLayout.schedule.schedule-dash'
                                        },
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.approvalWorkflowEnabled && scope.canApproveSchedule;
                                        }
                                    },
                                    {
                                        key: 'REGULAR_SCHEDULE_VARIATIONS',
                                        label: $filter("translate")('Regular Schedule Variations'),
                                        uiSref: {
                                            name: 'appLayout.schedule.regular-schedule-variations'
                                        },
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.isRegularScheduleVariationsEnabled;
                                        }
                                    },
                                ]
                            },
                            {
                                key: 'BUDGETING',
                                automation: 'teamHeaderBudgetingLink',
                                label: $filter("translate")('Budgeting'),
                                uiSref: {
                                    name: 'appLayout.schedule.budgeting'
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isBudgetingEnabled && scope.canManageBudget && scope.isEmployer;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.budgeting';
                                }
                            },
                            {
                                key: 'FORECASTS_AND_LABOR',
                                label: $filter("translate")('Forecasts & Labor'),
                                click: function () {
                                    return scope.redirectToForecastsAndLabor();
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.showForecastsAndLaborService() && scope.hasManageSchedulePermission && scope.hasSalesAccess;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return ['appLayout.schedule.wendys-labor', 'appLayout.schedule.mcd-labor', 'appLayout.schedule.gastronomy-labor', 'appLayout.schedule.carrol-labor', 'appLayout.schedule.forecasts-and-labor'].indexOf(scope.getCurrentState()) > -1;
                                },
                            },
                            {
                                key: 'FORECASTING',
                                automation: 'teamHeaderForecasting',
                                label: $filter("translate")('Forecasting'),
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isDemandForecastingEnabled && scope.isEmployer && scope.hasManageSchedulePermission && scope.hasSalesAccess;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return [
                                        'appLayout.schedule.forecasts-and-labor',
                                        'appLayout.schedule.wendys-labor',
                                        'appLayout.schedule.mcd-labor',
                                        'appLayout.schedule.gastronomy-labor',
                                        'appLayout.schedule.forecasts-historical-data'
                                    ].indexOf(scope.getCurrentState()) > -1;
                                },
                                subItems: [
                                    {
                                        key: 'FORECASTS_AND_LABOR_SUB',
                                        label: $filter("translate")('Forecasts & Labor'),
                                        click: function () {
                                            return scope.redirectToForecastsAndLabor();
                                        },
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.showLaborAndForecastsWithDemandForecasting() && scope.hasSalesAccess;
                                        }
                                    },
                                    {
                                        key: 'FORECASTS',
                                        label: $filter("translate")('Forecasts'),
                                        click: function () {
                                            return scope.redirectToForecastsAndLabor();
                                        },
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return !scope.showLaborAndForecastsWithDemandForecasting() && scope.hasSalesAccess;
                                        }
                                    },
                                    {
                                        key: 'HISTORICAL_DATA',
                                        automation: 'Historical Data',
                                        label: $filter("translate")('Historical Data'),
                                        uiSref: {
                                            name: 'appLayout.schedule.forecasts-historical-data'
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return scope.hasSalesAccess;
                                        }
                                    },
                                ]
                            },
                            {
                                key: 'PAR_LABOR',
                                label: $filter("translate")('Par Labor'),
                                uiSref: {
                                    name: 'appLayout.schedule.par-labor'
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isParLaborServiceEnabled && scope.isEmployer && scope.hasSalesAccess;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.par-labor';
                                },
                            },
                            {
                                key: 'AVAILABILITY',
                                label: $filter("translate")('Availability'),
                                click: function () {
                                    return scope.goToAvailability();
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return !scope.isEmployer;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.availability-requests';
                                },
                            },
                            {
                                key: 'REQUESTS',
                                label: $filter("translate")('Requests'),
                                automation: "headerRequestsLink",
                                isVisible: false,
                                checkVisibility: function () {
                                    return !scope.isEmployer &&
                                            scope.activeBrand ;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return [
                                        'appLayout.schedule.schedule-change-consent',
                                        'appLayout.schedule.absence-requests',
                                        'appLayout.schedule.shift-trading',
                                    ].indexOf(scope.getCurrentState()) > -1;
                                },
                                subItems: [
                                    {
                                        key: 'ABSENCE_REQUESTS',
                                        label: $filter("translate")('Absence Requests'),
                                        uiSref: {
                                            name: 'appLayout.schedule.absence-requests'
                                        },
                                        automation: "headerAbsenceRequestsLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.activeBrand && scope.showAbsencesRequests();
                                        }
                                    },
                                    {
                                        key: 'SICKNESS_REQUESTS',
                                        label: $filter("translate")('Sickness Requests'),
                                        uiSref: {
                                            name: 'appLayout.schedule.sickness-requests'
                                        },
                                        automation: "headerSicknessRequestsLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.isAbsenceTypeTabShown('SICKNESS');
                                        }
                                    },
                                    {
                                        key: 'SHIFTS_CONSENTS',
                                        label: $filter("translate")('Shifts Consents'),
                                        uiSref: {
                                            name: 'appLayout.schedule.schedule-change-consent'
                                        },
                                        automation: "shiftsConsentsLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.employeeConsentFlowEnabled;
                                        }
                                    },
                                    {
                                        key: 'EMPLOYEES_SHIFT_TRADING',
                                        label: $filter("translate")('Shift Trade Requests'),
                                        uiSref: {
                                            name: 'appLayout.schedule.shift-trading'
                                        },
                                        automation: "shiftTradeLink",
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return true;
                                        }
                                    }
                                ]
                            },
                            {
                                key: 'REQUESTS_EMPLOYER',
                                label: $filter("translate")('Requests'),
                                automation: "headerRequestsLink",
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isEmployer;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return [
                                        'appLayout.schedule.availability-requests',
                                        'appLayout.schedule.time-off',
                                        'appLayout.schedule.approved-requests',
                                        'appLayout.schedule.schedule-change-consent',
                                        'appLayout.schedule.sickness-requests',
                                        'appLayout.schedule.absence-requests'
                                    ].indexOf(scope.getCurrentState()) > -1;
                                },
                                subItems: [
                                    {
                                        key: 'SHIFT_TRADING',
                                        automation: 'shiftTradeHeader',
                                        label: $filter("translate")('Shift Trade Requests'),
                                        uiSref: {
                                            name: 'appLayout.schedule.shift-trading'
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return true;
                                        }
                                    },
                                    {
                                        key: 'AVAILABILITY_EMPLOYER',
                                        label: $filter("translate")('Availability'),
                                        uiSref: {
                                            name: 'appLayout.schedule.availability-requests'
                                        },
                                        automation: "headerAvailabilityRequestsLink",
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return scope.hasManageAvailabilityRequestsPermission;
                                        }
                                    },
                                    {
                                        key: 'TIME_OFF',
                                        label: $filter("translate")('Time Off'),
                                        uiSref: {
                                            name: 'appLayout.schedule.time-off'
                                        },
                                        automation: "headerTimeoffRequestsLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return (scope.isAbsenceTypeTabShown('TIME_OFF') &&
                                                scope.hasManageTimeOffRequestsPermission
                                            );
                                        }
                                    },
                                    {
                                        key: 'ABSENCE_REQUESTS_EMPLOYER',
                                        label: $filter("translate")('Absence Requests'),
                                        uiSref: {
                                            name: 'appLayout.schedule.absence-requests'
                                        },
                                        automation: "headerAbsenceRequestsLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return (
                                                scope.activeBrand &&
                                                scope.showAbsencesRequests() &&
                                                scope.hasManageAbsenceRequestsPermission
                                            );
                                        }
                                    },
                                    {
                                        key: 'SICKNESS_REQUESTS_EMPLOYER',
                                        label: $filter("translate")('Sickness Requests'),
                                        uiSref: {
                                            name: 'appLayout.schedule.sickness-requests'
                                        },
                                        automation: "headerSicknessRequestsLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return (scope.isAbsenceTypeTabShown('SICKNESS') &&
                                                scope.hasManageSicknessRequestsPermission
                                            );
                                        }
                                    },
                                    {
                                        key: 'TEAM_REQUESTS',
                                        label: $filter("translate")('Team Requests'),
                                        uiSref: {
                                            name: 'appLayout.schedule.approved-requests'
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return true;
                                        }
                                    },
                                    {
                                        key: 'EMPLOYEES_CONSENTS',
                                        label: $filter("translate")('Employees Consents'),
                                        uiSref: {
                                            name: 'appLayout.schedule.schedule-change-consent'
                                        },
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return scope.employeeConsentFlowEnabled;
                                        }
                                    },
                                ]
                            },
                            {
                                key: 'LIVEWIRE',
                                label: $filter("translate")('Livewire'),
                                click: function () {
                                    return scope.goToPerformance();
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.canViewLiveWireAndHarriLiveDashboards
                                        && scope.isEmployer
                                        && scope.isLPMEnabled
                                        && scope.hasSalesAccess
                                        && !scope.isLiveWireV2Enabled;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.performance';
                                },
                            },
                            {
                                key: 'LIVEWIRE_V2',
                                label: $filter("translate")('Livewire'),
                                click: function () {
                                    return scope.goToLiveWireV2();
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.canViewLiveWireAndHarriLiveDashboards
                                        && scope.isEmployer
                                        && scope.isLPMEnabled
                                        && scope.hasSalesAccess
                                        && scope.isLiveWireV2Enabled
                                        && (scope.isCarrolLaborServiceEnabled || scope.isWendysLaborServiceEnabled || scope.isABSServiceEnabled || scope.isMcDBrandReportingEnabled);
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.live-wire-v2';
                                },
                            },
                            {
                                key: 'TEAMHUB',
                                label: $filter("translate")('TeamHub'),
                                automation: "teamHeaderTeamHub",
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isClockTimeAppEnabled() && scope.isEmployer;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return [
                                        'appLayout.schedule.clock-time.timesheet',
                                        'appLayout.schedule.clock-time.announcements',
                                        'appLayout.schedule.clock-time.feedback'
                                    ].indexOf(scope.getCurrentState()) > -1;
                                },
                                subItems: [
                                    {
                                        key: 'PUNCH_MANAGEMENT',
                                        label: $filter("translate")('Punch Management'),
                                        uiSref: {
                                            name: 'appLayout.schedule.punch-management'
                                        },
                                        automation: "teamHeaderTeamhubPunchManagementLink",
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return scope.canManagePunchManagement;
                                        }
                                    },
                                    {
                                        key: 'TIMESHEET',
                                        label: $filter("translate")('Timesheet'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.timesheet'
                                        },
                                        automation: "teamHeaderTeamhubTimesheetLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.isAllowedAccessTimeSheet;
                                        },
                                    },
                                    {
                                        key: 'PAY_RUNS',
                                        label: $filter("translate")('Pay Runs'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.pay-runs'
                                        },
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.canManagePayRuns;
                                        }
                                    },
                                    {
                                        key: 'PAY_DATA_SHEET',
                                        label: $filter("translate")('Pay Data Sheet'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.pay-sheet'
                                        },
                                        automation: "teamHeaderTeamhubPaysheetLink",
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.isPaySheetAdmin && scope.showPayDataSheetOption;
                                        }
                                    },
                                    {
                                        key: 'REGULAR_SCHEDULE_INCIDENTS',
                                        label: $filter("translate")('Regular Schedule Incidents'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.gfe-incidents'
                                        },
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.isGFEServiceEnabled &&
                                                scope.incidentsTrackingSettings &&
                                                scope.incidentsTrackingSettings['state'] &&
                                                scope.incidentsTrackingSettings['state'] === 'NY' &&
                                                scope.canManageGFEIncidents;
                                        }
                                    }, {
                                        key: 'GFE_INCIDENTS',
                                        label: $filter("translate")('GFE Incidents'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.gfe-incidents'
                                        },
                                        isVisible: false,
                                        checkVisibility: function () {
                                            return scope.isGFEServiceEnabled &&
                                                scope.incidentsTrackingSettings &&
                                                scope.incidentsTrackingSettings['state'] &&
                                                scope.incidentsTrackingSettings['state'] != 'NY' &&
                                                scope.canManageGFEIncidents;
                                        }
                                    },
                                    {
                                        key: 'ANNOUNCEMENTS',
                                        label: $filter("translate")('Announcements'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.announcements'
                                        },
                                        automation: "teamHeaderTeamhubAnnouncementsLink",
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return true;
                                        }
                                    },
                                    {
                                        key: 'FEEDBACK',
                                        label: $filter("translate")('Feedback'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.feedback'
                                        },
                                        automation: "teamHeaderTeamhubFeedbacksLink",
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return true;
                                        }
                                    },
                                    {
                                        key: 'ALERTS',
                                        label: $filter("translate")('Alerts'),
                                        uiSref: {
                                            name: 'appLayout.schedule.clock-time.alerts'
                                        },
                                        automation: "teamHeaderTeamhubAlertsLink",
                                        isVisible: true,
                                        checkVisibility: function () {
                                            return true;
                                        }
                                    },
                                ]
                            },
                            {
                                key: 'DASHBOARDS',
                                label: $filter("translate")('Dashboards'),
                                isVisible: false,
                                hideIfNoVisibleChildren: true,
                                isActive: false,
                                checkActive: () => {
                                    return [
                                        'appLayout.schedule.tl-compaas-dashboard',
                                        'appLayout.harriSH.dashboards.risk',
                                    ].indexOf(scope.getCurrentState()) > -1;
                                },
                                subItems: [
                                    {
                                        key: 'COMPAAS_DASHBOARD',
                                        label: $filter("translate")('COMPaaS'),
                                        uiSref: {
                                            name: 'appLayout.schedule.tl-compaas-dashboard'
                                        },
                                        isVisible: false,
                                        checkVisibility: () => canViewCompaasDashboard,
                                    },
                                    {
                                        key: 'RISK_DASHBOARD',
                                        label: $filter("translate")('Risk Analysis'),
                                        uiSref: {
                                            name: 'appLayout.harriSH.dashboards.risk'
                                        },
                                        isVisible: false,
                                        checkVisibility: () => canViewRiskDashboard,
                                    },
                                ]
                            },
                            {
                                key: 'REPORTS',
                                label: $filter("translate")('Reports'),
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkReportsMenuVisibility(scope.activeBrand.id);
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState().indexOf('appLayout.schedule.reports.') > -1;
                                },
                                subItems: [
                                    {
                                        key: 'HR_REPORTS',
                                        type: 'SECTION',
                                        label: $filter("translate")('HR'),
                                        isVisible: false,
                                        sortableSubItems: true,
                                        hideIfNoVisibleChildren: true,
                                        subItems: [
                                            {
                                                key: 'ATTENDANCE_RELIABILITY',
                                                label: $filter("translate")('Attendance Reliability Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.attendance-reliability-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkAttendanceReliabilityVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'CONSENT_REPORT',
                                                label: $filter("translate")('Consent Reports'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.consent-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkConsentReportsVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'AVAILABILITY',
                                                label: $filter("translate")('Availability Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.availability'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkAvailabilityReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'EMPLOYEE_ROSTER',
                                                label: $filter("translate")('Employee Roster'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.employee-roster'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkEmployeeRostertVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'ABSENCE_TRACKER_REPORT',
                                                label: $filter("translate")('Absence Tracker Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.absence-tracker-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkAbsenceTrackerVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'TURNOVER_REPORT_V2',
                                                label: $filter("translate")('Employee Turnover Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.turnover-report'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkTurnoverReportVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'CLOCK_IN_MESSAGE',
                                                label: $filter("translate")('Clock-in Message'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.clock-in-message-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkClockInMessageVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'EMPLOYEE_DETAILED_SATISFACTION_REPORT',
                                                label: $filter("translate")('Employee Detailed Satisfaction Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.employee-detailed-satisfaction-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkEmployeeDetailedSatisfactionReportVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'EMPLOYEE_EDITS_REPORT',
                                                label: $filter("translate")('Employee Edits Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.employee-edits-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkEmployeeEditsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'EMPLOYEE_HEALTH_CHECK_REPORT',
                                                label: $filter("translate")('Employee Health Check Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.covid-19-employees-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkEmployeeHealthCheckReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'GFE_DOCUMENTS_TRACKING_REPORT',
                                                label: $filter("translate")('GFE Documents Tracking Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.gfe-documents-tracking-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkGFEDocumentTrackingVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'HEALTH_CHECK_SUMMARY_REPORT',
                                                label: $filter("translate")('Health Check Summary Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.employee-health-check-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkHealthCheckSummaryReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'HOLIDAY_ALLOWANCE_REPORT',
                                                label: $filter("translate")('Holiday Allowance Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.holiday-allowance'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkHolidayAllowanceReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'TEAM_MEMBER_MASTER_REPORT',
                                                label: $filter("translate")('Team Member Master Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.team-member-master-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkTeamMemberMasterReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'UNEMPLOYMENT_CLAIMS_REPORT',
                                                label: $filter("translate")('Unemployment Claims Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.unemployment-claims-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return (
                                                        scope.activeBrand?.id &&
                                                        reportsPrerequisiteService.checkUnemploymentClaimsReportVisibility(
                                                            scope.activeBrand.id
                                                        )
                                                    );
                                                },
                                            }
                                        ]
                                    },
                                    {
                                        key: 'TIME_KEEPING_REPORTS',
                                        type: 'SECTION',
                                        label: $filter("translate")('Timekeeping'),
                                        isVisible: false,
                                        sortableSubItems: true,
                                        hideIfNoVisibleChildren: true,
                                        subItems: [
                                            {
                                                key: 'DAILY_ACTIVITY_REPORT',
                                                label: $filter("translate")('Daily Activity Report') + ' (DAR)',
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.daily-activity-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkDARVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'PAY_PERIOD_REPORT',
                                                label: $filter("translate")('Pay Period Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.pay-period-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkPayPeriodReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'LABOR_ANALYSIS',
                                                label: $filter("translate")('Labor Analysis Report') + ' (LAB)',
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.labor-analysis-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkLaborAnalysisReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'MCD_PUNCH_REPORTS',
                                                label: $filter("translate")('Punch Reports'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.punch-reports'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkPunchReportsVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'LABOR_EXCEPTION_REPORT',
                                                label: $filter("translate")('Labor Exception Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.labor-exception-report'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkLaborExceptionReportVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'APPROACHING_WEEKLY_OT_REPORT',
                                                label: $filter("translate")('Approaching Weekly OT Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.overtime-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkApproachingWeeklyOTReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'BREAKS_REPORT',
                                                label: $filter("translate")('Breaks Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.scheduled-breaks-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkBreaksReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'FWW_PREMIUMS_REPORT',
                                                label: $filter("translate")('FWW Premiums Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.premium-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkFWWPremiumsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'MISSED_BREAKS_REPORT',
                                                label: $filter("translate")('Missed Breaks Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.missed-breaks'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkMissedBreaksReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'FORECAST_ACCURACY_REPORT',
                                                label: $filter("translate")('Forecast Accuracy Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.forecast-accuracy-report'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkForecastAccuracyReportVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'PUNCH_DETAIL_REPORT',
                                                label: $filter("translate")('Punch Detail Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.punch-detail-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkPunchDetailReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'PUNCH_PHOTOS_EXCEPTIONS_REPORT',
                                                label: $filter("translate")('Punch Photos Exceptions Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.punch-photos-exceptions-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkPunchPhotosExceptionsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'TIME_CARD_EDITS_REPORT',
                                                label: $filter("translate")('Time Card Edits Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.time-card-edits-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkTimeCardEditsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'TIMESHEET_REPORT',
                                                label: $filter("translate")('Timesheet Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.time-sheet-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkTimeSheetReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'WAGE_TYPE_SUMMARY',
                                                label: $filter("translate")('Wage Type Summary'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.wage-type-summary-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkWageTypeSummaryReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'NO_PAY_REPORT',
                                                label: $filter("translate")('No Pay Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.no-pay-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkNoPayReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                        ]
                                    },
                                    {
                                        key: 'SCHEDULING_REPORTS',
                                        type: 'SECTION',
                                        label: $filter("translate")('Scheduling'),
                                        isVisible: false,
                                        sortableSubItems: true,
                                        hideIfNoVisibleChildren: true,
                                        subItems: [
                                            {
                                                key: 'DAILY_CREW_SCHEDULE',
                                                label: $filter("translate")('Daily Crew Schedule') + ' (' + $filter('translate')('Line Bar') + ')',
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.daily-crew-schedule-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkDailyCrewScheduleReportVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'SCHEDULE_CHANGE_REPORTING',
                                                label: $filter("translate")('Schedule Change Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.schedule-change-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkScheduleChangeReportVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'WEEKLY_SCHEDULE_REPORT',
                                                label: $filter("translate")('Weekly Schedule Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.weekly-schedule-report'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkWeeklyScheduleReportVisibility(scope.activeBrand.id);
                                                }
                                            },
                                            {
                                                key: 'AVAILABLE_SHIFTS_REPORT',
                                                label: $filter("translate")('Available Shifts Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.available-shifts'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkAvailableShiftsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'DETAILED_EMPLOYEE_LABOUR_REPORT',
                                                label: $filter("translate")('Detailed Employee Labour Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.detailed-employee-labor-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkDetailedEmployeeLaborReportVisibility(scope.activeBrand.id);
                                                },
                                                getLabel: function () {
                                                    if (['US', 'PH'].indexOf(scope.isUSOrPHBrand) === -1) {
                                                        return $filter("translate")('Detailed Employee Labour Report')
                                                    } else {
                                                        return $filter("translate")('Detailed Employee Labor Report')
                                                    }
                                                },
                                            },
                                            {
                                                key: 'EMPLOYEE_LABOUR_VARIANCE_REPORT',
                                                label: $filter("translate")('Employee Labour Variance Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.employee-labor-variance-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkEmployeeLaborVarianceReportVisibility(scope.activeBrand.id);
                                                },
                                                getLabel: function () {
                                                    if (['US', 'PH'].indexOf(scope.isUSOrPHBrand) === -1) {
                                                        return $filter("translate")('Employee Labour Variance Report')
                                                    } else {
                                                        return $filter("translate")('Employee Labor Variance Report')
                                                    }
                                                },
                                            },
                                            {
                                                key: 'FLASH_DASH_REPORT',
                                                label: $filter("translate")('Flash Dash Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.enterprise-flash-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkEnterpriseFlashReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'FLASH_DASH_REPORT_V2',
                                                label: $filter("translate")('Flash Report V2'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.flash-report-v2'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkFlashReportV2Visibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'LABOUR_VARIANCE_REPORT',
                                                label: $filter("translate")('Labour Variance Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.labor-variance-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkLaborVarianceReportVisibility(scope.activeBrand.id);
                                                },
                                                getLabel: function () {
                                                    if (['US', 'PH'].indexOf(scope.isUSOrPHBrand) === -1) {
                                                        return $filter("translate")('Labour Variance Report')
                                                    } else {
                                                        return $filter("translate")('Labor Variance Report')
                                                    }
                                                },
                                            },
                                            {
                                                key: 'LOGBOOK_CHECKLISTS_REPORT',
                                                label: $filter("translate")('Logbook Checklists Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.logbook-checklists-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkLogbookChecklistsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'LOGBOOK_ENTRIES_REPORT',
                                                label: $filter("translate")('Logbook Entries Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.logbook-entries-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkLogbookEntriesReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'LOGBOOK_TASKS_REPORT',
                                                label: $filter("translate")('Logbook Tasks Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.logbook-tasks-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkLogbookTasksReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'NEEDED_HOURS_REPORT',
                                                label: $filter("translate")('Needed Hours'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.needed-hours-report'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkNeededHoursReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'SCHEDULE_AUDIT_REPORT',
                                                label: $filter("translate")('Schedule Audit Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.schedule-audit-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkScheduleAuditReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'SCHEDULING_STATUS_REPORT',
                                                label: $filter("translate")('Scheduling Status Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.scheduling-status'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkScheduleStatusReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'UNSCHEDULED_EMPLOYEE_REPORT',
                                                label: $filter("translate")('Unscheduled Employee Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.unscheduled-employee-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkUnscheduledEmployeeReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'SCHEDULE_CREATION_METRIC_REPORT',
                                                label: $filter('translate')('Schedule Creation Metrics Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.schedule-creation-metric'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkMetricsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'REGULAR_SCHEDULE_VARIATION_REPORT',
                                                label: $filter("translate")("Regular Schedule Variations Report"),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.regular-schedule-variation-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkRegularScheduleVariationsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                        ]
                                    },
                                    {
                                        key: 'INTEGRATIONS_REPORTS',
                                        type: 'SECTION',
                                        label: $filter("translate")('Integrations'),
                                        isVisible: false,
                                        sortableSubItems: true,
                                        hideIfNoVisibleChildren: true,
                                        subItems: [
                                            {
                                                key: 'INTEGRATION_REJECTION',
                                                label: $filter("translate")('McD Integration Rejection Reports'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.integration-rejection-report'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkIntegrationRejectionReportsVisibility(scope.activeBrand.id);
                                                },
                                            },
                                        ]
                                    },
                                    {
                                        key: 'ONBOARDING_JOURNEY',
                                        type: 'SECTION',
                                        label: $filter("translate")('Harri Engage'),
                                        isVisible: false,
                                        sortableSubItems: true,
                                        hideIfNoVisibleChildren: true,
                                        subItems: [
                                            {
                                                key: 'POLL_EVENTS_REPORT',
                                                label: $filter("translate")('Engagement Ratings Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.engagement-ratings-report'
                                                },
                                                isVisible: true,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkPollEventsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                            {
                                                key: 'ONBOARDING_JOURNEY_EVENTS_REPORT',
                                                label: $filter("translate")('Engagement Non-Ratings Report'),
                                                uiSref: {
                                                    name: 'appLayout.schedule.reports.engagement-non-ratings-report'
                                                },
                                                isVisible: false,
                                                checkVisibility: function () {
                                                    return scope.activeBrand && scope.activeBrand.id && reportsPrerequisiteService.checkOnboardingJourneyEventsReportVisibility(scope.activeBrand.id);
                                                },
                                            },
                                        ]
                                    },
                                ]
                            },
                            {
                                key: 'TIMESHEET_EMPLOYEE',
                                label: $filter("translate")('Timesheet'),
                                uiSref: {
                                    name: 'appLayout.schedule.clock-time.timesheet'
                                },
                                isVisible: false,
                                checkVisibility: function () {
                                    return scope.isClockTimeAppEnabled() && !scope.isEmployer && scope.isTimesheetEnabled;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.clock-time.timesheet';
                                },
                            },
                            {
                                key: 'SETTINGS',
                                label: $filter("translate")('Settings'),
                                click: function () {
                                    return scope.goToSettings();
                                },
                                isVisible: true,
                                checkVisibility: function () {
                                    return scope.activeBrand && scope.isSettingsTabShown;
                                },
                                isActive: false,
                                checkActive: function () {
                                    return scope.getCurrentState() === 'appLayout.schedule.settings';
                                },
                            },
                        ];

                        allHeaderItems.forEach(function (headerItem) {
                            if (headerItem.key === 'REPORTS') {
                                headerItem.subItems.sort(function (a, b) {
                                    if (a.label < b.label) return -1;
                                    if (a.label > b.label) return 1;

                                    return  0
                                });
                            }

                            return headerItem;
                        });

                        var mainItemsKeysWithOriginalSort = allHeaderItems.map(function (item) {
                            return item.key;
                        });

                        scope.allHeaderItems = angular.copy(allHeaderItems);
                        scope.headerItems = [];
                        scope.moreItems = [];
                        scope.isLMSElearningServiceEnabled = false;

                        scope.isReverseSubMenuApplied = function () {
                            return scope.userType === scope.MEMBER_TYPES.EMPLOYEE || (!scope.isBackToHarriEnabled && (!scope.isBarriEnabled || !scope.allowedBarriRoutes || !scope.allowedBarriRoutes.length))
                        }

                        var sortHeaderItems = function () {
                            allHeaderItems = headerItemsService.sortHeaderItems(allHeaderItems, mainItemsKeysWithOriginalSort)
                            allHeaderItems = headerItemsService.sortHeaderItems(allHeaderItems, navBarPreference)
                        };

                        var processHeaderItems = function () {
                            allHeaderItems = headerItemsService.processHeaderItems(allHeaderItems);
                            sortHeaderItems();
                            handleHeaderItemsPosition();
                        };

                        var calculateItemsWidth = function () {
                            moreLinkWidth = $('#header-more-link').width();
                            allHeaderItems.forEach(function (item) {
                                item.width = $('#hidden-nav-container').find("[data-key='" + item.key + "']").width() || 0;
                            });
                        };

                        scope.checkHeaderItems = function () {
                            processHeaderItems();
                            return true;
                        };

                        var resizeTimeout;

                        var handleHeaderItemsPosition = function () {
                            clearTimeout(resizeTimeout);
                            resizeTimeout = setTimeout(function () {
                                var availableWidth = $('#header-links-nav').outerWidth(true) - 15;
                                allHeaderItems = headerItemsService.handleHeaderItemsPosition(allHeaderItems, availableWidth, moreLinkWidth);
                                var headerItems = allHeaderItems.filter(function (item) {
                                    return !item.isInMore;
                                });
                                var moreItems = allHeaderItems.filter(function (item) {
                                    return item.isInMore;
                                });
                                if (!headerItemsService.isSameItems(headerItems, scope.headerItems)
                                    || !headerItemsService.isSameItems(moreItems, scope.moreItems)) {
                                    scope.headerItems = headerItems;
                                    scope.moreItems = moreItems;
                                    scope.$digest();
                                }
                            }, 10);
                        };


                        var getAllVisibleLinks = function () {
                            return allHeaderItems.filter(function (item) {
                                return item.isVisible;
                            });
                        };

                        scope.openLinksPreferencesModal = function () {
                            $modal({
                                controller: 'headerLinksPreferencesModalController',
                                controllerAs: '$ctrl',
                                templateUrl: '../scripts/global-directives/header-links-preferences-modal/header-links-preferences.modal.html',
                                show: true,
                                backdrop: 'static',
                                resolve: {
                                    modalData: function () {
                                        return {
                                            links: getAllVisibleLinks(),
                                            brandId: scope.activeBrand.id,
                                            groupId: hUser.getUserContext().brand_id,
                                            accessLevel: headerItemsService.ACCESS_LEVELS.TEAM_LIVE
                                        };
                                    },
                                    onSave: function () {
                                        return function (preference) {
                                            navBarPreference = preference;
                                            sortHeaderItems();
                                        };
                                    }
                                }
                            });
                        };

                        var tsSideBar = new TSSideBarService();
                        var teamCommunication = new TeamCommunicationService();
                        var userId = hUser.data.user.team_user_id;

                        scope.isMobile = $(window).width() < 1025;
                        scope.showBrandsList = false;
                        scope.MEMBER_TYPES = TSUtils.MEMBER_TYPES;
                        scope.userType = hUser.getUserType();
                        scope.isEmployer = hUser.isEmployer();
                        if(scope.isEmployer){
                            scope.hasSalesAccess = hUser.hasSalesAccess();
                        }

                        scope.isClockTimeAppEnabled = TeamScheduleService.isClockTimeAppEnabled;

                        scope.getCurrentState = function () {
                            return $state.current.name;
                        };

                        //Main Dropdown menu
                        scope.isBrandSwitchOpen = false;

                        TSUsersService.onUsersLoaded(function () {
                            scope.userData = TSUsersService.users[userId];
                            scope.$digest();
                        });

                        //Some ts sidebar logi
                        tsSideBar.onChange(function (isOpened) {
                            if (isOpened) {
                                closeMainDropdown();
                                $('.ts-header-one .navigation-button').addClass('toggled');
                            } else {
                                $('.ts-header-one .navigation-button').removeClass('toggled');
                            }
                        });

                        var commsHubMessagesCountEvent = commshubService.on('unread_messages_changed', function () {
                            commshubService.reset();
                            getUnseenMessagesCount();
                        });

                        scope.closeSideBar = function () {
                            tsSideBar.close();
                        };

                        scope.openSideBar = function () {
                            if (hUser.isEmployer()) {
                                if (scope.isNewsFeedService) {
                                    tsSideBar.open();
                                }
                            } else {
                                tsSideBar.open();
                            }
                        };

                        scope.toggleUserMenu = function () {
                            scope.isMenuOpen = !scope.isMenuOpen;
                        };

                        scope.showMyProfile = function (brand) {
                            teamCommunication.showMemberProfile(brand.id, userId);
                            scope.toggleUserMenu();
                            tsSideBar.open();
                        };

                        /**
                         * Main Dropdown Logic
                         */

                        scope.isAccountSwitchEnabled = function () {
                            return $state.current.name != 'appLayout.schedule.view-employee-schedule';
                        };

                        //Toggle the mainDropDown
                        var openMainDropdown = function () {
                            scope.isMainDropdownOpen = true;
                            $('.ts-header-one .navigation-button').addClass('toggled');
                            $('body').addClass('schedule-main-dropdown-open');
                        };

                        var closeMainDropdown = function () {
                            scope.isMainDropdownOpen = false;
                            scope.isBrandSwitchOpen = false;
                            $('.ts-header-one .navigation-button').removeClass('toggled');
                            $('body').removeClass('schedule-main-dropdown-open');
                        };

                        var toggleMainDropdown = function () {
                            if (scope.isMainDropdownOpen) {
                                closeMainDropdown();
                            }
                            else {
                                openMainDropdown();
                            }
                        };

                        var initPermissions = function (policyParser) {

                            scope.isPaySheetAdmin = policyParser.has(userPermissions.PERMISSIONS.ADVANCED_PDS_ACCESS);
                            scope.isAllowedAccessTimeSheet = policyParser.hasAny(userPermissions.MANAGE_TIME_CARDS);
                            scope.isBackToHarriEnabled = policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);
                            scope.canManageBudget = policyParser.has(userPermissions.PERMISSIONS.MANAGE_BUDGET);
                            scope.canManageGFEIncidents = policyParser.has(userPermissions.PERMISSIONS.MANAGE_GFE_INCIDENTS);
                            scope.canApproveAndPublishSchedule = policyParser.has(userPermissions.PERMISSIONS.PUBLISH_SCHEDULE);
                            scope.canApproveSchedule = policyParser.has(userPermissions.PERMISSIONS.APPROVE_SCHEDULE);
                            scope.canManageSchedule = policyParser.has(userPermissions.PERMISSIONS.MANAGE_SCHEDULE);
                            scope.hasManagePayRunsAccess = policyParser.has(userPermissions.PERMISSIONS.MANAGE_PAYSHEET_PAYRUN);
                            scope.canManageEmployeeQuestionnaire = policyParser.categories(policyParser.ANY).has(userPermissions.PERMISSIONS.MANAGE_EMPLOYEE_QUESTIONNAIRE);
                            scope.canViewEmployeesSatisfaction = policyParser.categories(policyParser.ANY).has(userPermissions.PERMISSIONS.MANAGE_VIEW_SATISFACTION);
                            scope.canManagePunchManagement = policyParser.has(userPermissions.PERMISSIONS.CAN_MANAGE_USER_PUNCHES);
                            scope.hasManageSchedulePermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_SCHEDULE);
                            scope.canViewLiveWireAndHarriLiveDashboards = policyParser.has(userPermissions.PERMISSIONS.VIEW_LIVE_WIRE_AND_HARRI_LIVE_DASHBOARDS);
                            scope.hasManageAbsenceRequestsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_ABSENCE_REQUESTS);
                            scope.hasManageSicknessRequestsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_SICKNESS_REQUESTS);
                            scope.hasManageTimeOffRequestsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_TIMEOFF_REQUESTS);
                            scope.hasManageAvailabilityRequestsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_AVAILABILITY_REQUESTS);
                        };

                        var getAcademyRedirectionLink = function() {
                            UserAPI.getAcademyLink()
                                .then(function(res) {
                                    scope.academyRedirectionLink = res['redirection_link'];
                                })
                                .catch(function (err) {
                                    console.error(err && err.data);
                                })
                                .finally(function () {
                                    scope.$digest();
                                });
                        };


                        //Unseen messages count
                        var getUnseenMessagesCount = function () {
                            scope.unseenMessagesCount = 0;
                            if (scope.activeBrand && scope.activeBrand.id) {
                                if (scope.isCommsHubServiceEnabled || (!scope.isEmployer && scope.employeeHaveCommsHub)) {
                                    var method;
                                    if (scope.isEmployer) {
                                        method = commshubService.getEmployerUnreadMessagesCount();
                                    } else {
                                        method = commshubService.getEmployeeUnreadMessagesCount(scope.activeBrand.id);
                                    }
                                    method.then(function (count) {
                                        scope.unseenMessagesCount = count;
                                    });
                                }
                            }
                        };

                        scope.closeMenu = function () {
                            scope.isMenuOpen = false;
                        };

                        //Header Navigation Icon
                        scope.triggerNavigation = function () {
                            if (scope.isMobile) {
                                if (tsSideBar.isOpened()) {
                                    tsSideBar.close();
                                } else {
                                    toggleMainDropdown();
                                }
                            } else {
                                scope.closeSideBar();
                            }
                        };

                        //Brand switch dropdown
                        scope.toggleBrandSwitch = function () {
                            scope.isBrandSwitchOpen = !scope.isBrandSwitchOpen;
                        };

                        scope.goToWall = function () {
                            teamCommunication.showTeamWall();
                            tsSideBar.open();
                        };

                        scope.goToTimeOff = function () {
                            if (hUser.isEmployer()) {
                                $state.go('appLayout.schedule.time-off');

                                if (scope.isMobile) {
                                    closeMainDropdown();
                                }
                            } else {
                                teamCommunication.showTimeOffRequests();
                                tsSideBar.open();
                            }
                        };

                        scope.goToShiftOffer = function () {
                            $state.go('appLayout.schedule.shift-trading');
                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToHomepage = function () {
                            Utils.redirectToWorkspace('homepage');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToSchedule = function () {
                            $state.go('appLayout.schedule.main');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToTeamSchedule = function() {
                            $state.go('appLayout.schedule.teamschedule');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToHoursAndForecasting = function () {
                            $state.go('appLayout.schedule.schedule-hours-and-forecasting');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToTeam = function () {
                            if (hUser.isEmployer()) {
                                var reloadPage = scope.getCurrentState() === 'appLayout.schedule.core-hr.list';
                                $state.go('appLayout.schedule.core-hr.list', {source: 'TL'}, {reload: reloadPage});
                            } else {
                                $state.go('appLayout.schedule.team');
                            }

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToCommunicationHub = function () {
                            $state.go('appLayout.schedule.tl-communication-hub.message');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.getDashboardUrl = function() {
                            return $state.href('appLayout.harriSH.dashboard');
                        };


                        scope.goToAvailability = function() {
                            $state.go('appLayout.schedule.availability-requests');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToTimeSheet = function() {
                            $state.go('appLayout.schedule.clock-time.timesheet');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToSettings = function () {
                            $state.go('appLayout.schedule.settings');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToCoreHR = async () => {
                            var isHMAPUser = hUser.isHMAPUser();

                            if (isHMAPUser || scope.isBackToHarriEnabled) {
                                hUser.clearUserContext();
                                var coreHrProfileURL = $state.href('appLayout.harriSH.core-hr.list');
                                window.open(coreHrProfileURL,'_blank');
                            } else {
                                $state.go('appLayout.schedule.core-hr.list', {source: null}, {reload: true});
                            }
                        };

                        scope.goToPerformance = function () {
                            $state.go('appLayout.schedule.performance');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.goToLiveWireV2 = function () {
                            $state.go('appLayout.schedule.live-wire-v2');
                        };

                        scope.goToDashboard = function () {
                            $state.go('appLayout.harriSH.dashboard');

                            if (scope.isMobile) {
                                closeMainDropdown();
                            }
                        };

                        scope.isHMAPUser = function () {
                            return hUser.isEmployer() ? hUser.isHMAPUser() : false;
                        };

                        scope.logout = function () {
                            hLoginManager.signOut();
                        };

                        scope.showAbsencesRequests = function () {
                            for (var i in scope.activeBrand['brand_absences']) {
                                var brandAbsence = scope.activeBrand['brand_absences'][i];
                                if (['CUSTOM', 'PATERNITY' , 'BEREAVEMENT', 'MATERNITY', 'SHARED_PARENTAL', 'ADOPTION', 'HOLIDAY'].indexOf(brandAbsence.type) > -1) {
                                    return true;
                                }
                            }
                            return false;
                        };

                        scope.isAbsenceTypeTabShown = function(type) {
                            if (scope.activeBrand && scope.activeBrand['brand_absences']) {
                                return scope.activeBrand['brand_absences'].find(function (absences) {
                                    return absences['type'] === type;
                                })
                            }
                            return false;
                        };

                        scope.showLaborAndForecastsWithDemandForecasting = function () {
                            return (
                                scope.isWendysLaborServiceEnabled ||
                                scope.isMcDLaborServiceEnabled ||
                                scope.isGastronomyLaborServiceEnabled ||
                                scope.isCarrolLaborServiceEnabled ||
                                scope.isABSServiceEnabled
                            );
                        };

                        var showPayDataSheetTab = function (policyParser, payDataSheets) {
                            for (var i in payDataSheets) {
                                var viewWagesPermissions = [];
                                var brandPaysheetTypes = payDataSheets[i].brand_paysheet_types;
                                for (var j in brandPaysheetTypes) {
                                    if (brandPaysheetTypes[j].paysheet_type === 'WEIGHTED_SHIFT') {
                                        viewWagesPermissions.push(userPermissions.PERMISSIONS.VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES);
                                    }
                                    else if (brandPaysheetTypes[j].paysheet_type === 'HOURLY') {
                                        viewWagesPermissions.push( userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES);
                                    }
                                    else if (brandPaysheetTypes[j].paysheet_type === 'SALARIED') {
                                        viewWagesPermissions.push(userPermissions.PERMISSIONS.VIEW_SALARIED_EMPLOYEES_WAGES);
                                    }
                                }

                                if (scope.activeBrand.paysheet_payroll_type === 'DATA_PASS') {
                                    if (policyParser.hasAny(viewWagesPermissions)) {
                                        return true;
                                    }
                                }
                                 else {
                                    if (policyParser.categories(policyParser.ALL).hasAll(viewWagesPermissions)) {
                                        return true;
                                    }
                                }
                            }
                           return false;
                        };

                        var formatEmployeeBusinesses = function (employeeBusinessesData, brandsData) {
                            var formattedBrands = [];
                            for (var i in employeeBusinessesData) {
                                var businessBrand = employeeBusinessesData[i];
                                let businessBrandObj = {name: businessBrand.name, id: businessBrand.id, locations: []}
                                for (var j in brandsData) {
                                    var brand = brandsData[j];
                                    if (brand.business_id === businessBrand.id) {
                                        businessBrandObj.locations.push(brand)
                                    }
                                }
                                if (businessBrandObj.locations.length) {
                                    formattedBrands.push(businessBrandObj);
                                }
                            }
                            return formattedBrands;
                        }

                        var getBrandsList = function (brands) {
                            var enterpriseBrands = [];
                            var notEnterpriseBrands = [];

                            for (var i in brands) {
                                var brand = brands[i];
                                if (brand.type === 'ENTERPRISE') {
                                    enterpriseBrands.push(brand);
                                } else {
                                    notEnterpriseBrands.push(brand);
                                }

                            }

                            notEnterpriseBrands.sort(function (brandA, brandB) {
                                return brandA.name.toLowerCase() > brandB.name.toLowerCase() ? 1 : -1;
                            });

                            return enterpriseBrands.concat(notEnterpriseBrands);

                        }

                        scope.selectBusiness = function (businessId, dontUpdateBackend) {
                            if (scope.activeBusiness && scope.activeBusiness.id == businessId.id) {
                                return;
                            }
                            scope.activeBusiness = scope.employeeBusinesses.find(function (business) {
                                return business.id === businessId;
                            });
                            if (!dontUpdateBackend) {
                                scope.selectBrand(scope.activeBusiness.locations[0]);
                            }
                        };

                        let isEmployeeConsentFlowEnabledAtBusiness = (employeeBusinesses, activeBusiness) => {
                            let currentBusinessBrand = employeeBusinesses.find(business => business.id === activeBusiness.id);

                            return currentBusinessBrand?.locations.some(location => {
                                return location?.fair_work_week_settings?.penalty_general_settings?.employee_consent_flow_enabled;
                            });

                        };

                        var init = function (brand) {
                            var promises = {
                                'brands': TeamScheduleService.getBrands(),
                            }
                            if (scope.userType === TSUtils.MEMBER_TYPES.EMPLOYEE) {
                                promises['employee_businesses'] = TeamScheduleService.getEmployeeBusinesses();
                            }

                            $q.all(promises)
                                .then(function (res) {
                                    var brands = res['brands'];

                                    if (res['employee_businesses']) {
                                        var employeeBusinessesData = res['employee_businesses'];
                                        scope.employeeBusinesses = formatEmployeeBusinesses(employeeBusinessesData, brands);
                                    }
                                    scope.brandsList = getBrandsList(brands);

                                    if (brands.length == 0) {
                                        hAlert($filter("translate")("Error"), $filter("translate")("This user has no brands!"));
                                    }
                                    var activeBrandPromises = {};
                                    if (!brand) {
                                        activeBrandPromises['active_brand'] = TeamScheduleService.getActiveBrand()
                                    }
                                    $q.all(activeBrandPromises)
                                        .then(function (res) {
                                            brand = brand || res['active_brand'];
                                            scope.activeBrand = brand;
                                            versionManager.init(brand.id)
                                            if (scope.userType === TSUtils.MEMBER_TYPES.EMPLOYEE) {
                                                scope.selectBusiness(brand.business_id, true);

                                            }

                                            scope.selectBrand(brand, true, true);


                                            scope.isUSOrPHBrand = brand.team_live_country_code;
                                            scope.isUKBrand = brand.team_live_country_code === "UK";
                                            scope.isDKBrand = brand.team_live_country_code === "DK";

                                            teamCommunication = new TeamCommunicationService();
                                            if (scope.userType === TSUtils.MEMBER_TYPES.EMPLOYEE) {
                                                scope.showNewsFeed = (brand.services || []).indexOf(userServices.SERVICES.NEWS_FEED) > -1;
                                                TSUsersService.loadUsers(scope.activeBrand.id, [userId]);
                                            } else if (!TSUsersService.isUserLoaded(userId)) {
                                                TSUsersService.loadUsers(scope.activeBrand.id, [userId]);
                                            }

                                            if (hUser.isEmployer()) {
                                                reportsPrerequisiteService.iniReportsPrerequisite(brand);
                                                userPermissions.getBrandPolicy(brand.id)
                                                    .then(function (policyParser) {
                                                        initPermissions(policyParser);

                                                        var promises = {};

                                                    promises['navBarPreference'] = headerItemsService.getNavBarPreference(hUser.getUserContext().brand_id, brand.id, headerItemsService.ACCESS_LEVELS.TEAM_LIVE);
                                                    promises['isParLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.PAR_LABOR, brand.id);
                                                    promises['isCommsHubServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ENTERPRISE_COMMUNICATION, brand.id);
                                                    promises['isCustomReportsServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.CUSTOM_REPORTS, brand.id);
                                                    promises['isNewsFeedService'] = userServices.isServiceEnabled(userServices.SERVICES.NEWS_FEED, brand.id);
                                                    promises['isABSServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, brand.id);
                                                    promises['isDemandForecastingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.DEMAND_FORECASTING, brand.id);
                                                    promises['isWendysLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.WENDYS_LABOR_MODEL, brand.id);
                                                    promises['isMcDLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.MCD_LABOR_MODEL, brand.id);
                                                    promises['isGastronomyLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.GASTRONOMY_LABOR_MODEL, brand.id);
                                                    promises['isCarrolLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.CARROL_LABOR_MODEL, brand.id);
                                                    promises['scheduleSettings'] = TeamScheduleAPI.getScheduleSettings(brand.id);
                                                    promises['isLiveWireV2Enabled'] = userServices.isServiceEnabled(userServices.SERVICES.LIVE_WIRE_V2_DASHBOARD, brand.id);
                                                    promises['isMcDBrandReportingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.MCD_BRAND_REPORTING, brand.id);
                                                    promises['isBudgetingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.SCHEDULE_BUDGETING, brand.id);

                                                    if (scope.hasManagePayRunsAccess) {
                                                        promises['check_payruns_tree'] = PerformanceAggregatorAPI.getBrandPayrunsTree(brand.id);
                                                    }

                                                promises['isLogbookEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.LOGBOOK, brand.id);
                                                promises['isGFEServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.GFE_INCIDENTS_TRACKING, brand.id);
                                                promises['isTeamQuestionnaireServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.TEAM_QUESTIONING, brand.id);
                                                promises['isBarriEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ANALYTICS_BARRI, brand.id);
                                                promises['paySheetTypes'] = PerformanceAggregatorAPI.getPaysheetTypes(brand.id, true);
                                                promises['isSettingsTabShown'] = TLEmployerSettingsDataService.canShowTLSettings(brand.id, scope.activeBrand.financial_unit_brand_id);
                                                promises['isLPMEnabled'] = brandServices.check(brandServices.SERVICES.POS, brand.id, true);
                                                promises['canViewCompaasDashboard'] = dashboardsPrerequisiteService.canViewCompaasDashboard(brand.id);
                                                promises['canViewRiskDashboard'] = dashboardsPrerequisiteService.canViewRiskDashboard(brand.id);

                                                    $q.all(promises)
                                                        .then(function (res) {
                                                            navBarPreference = res['navBarPreference'];
                                                            sortHeaderItems();
                                                            scope.isParLaborServiceEnabled = res.isParLaborServiceEnabled;
                                                            scope.isCommsHubServiceEnabled = res.isCommsHubServiceEnabled;
                                                            scope.isCustomReportsServiceEnabled = res.isCustomReportsServiceEnabled;
                                                            scope.isNewsFeedService = res.isNewsFeedService;
                                                            scope.isABSServiceEnabled = res.isABSServiceEnabled;
                                                            scope.isDemandForecastingEnabled = res.isDemandForecastingEnabled;
                                                            scope.isWendysLaborServiceEnabled = res.isWendysLaborServiceEnabled;
                                                            scope.isMcDLaborServiceEnabled = res.isMcDLaborServiceEnabled;
                                                            scope.isGastronomyLaborServiceEnabled = res.isGastronomyLaborServiceEnabled;
                                                            scope.isCarrolLaborServiceEnabled = res.isCarrolLaborServiceEnabled;
                                                            scope.approvalWorkflowEnabled = res.scheduleSettings.schedule_publish_mode === 'SUBMISSION';
                                                            scope.employeeConsentFlowEnabled = res.scheduleSettings.fair_work_week_settings
                                                                && res.scheduleSettings.fair_work_week_settings.penalty_general_settings
                                                                && res.scheduleSettings.fair_work_week_settings.penalty_general_settings.employee_consent_flow_enabled;
                                                            scope.isBudgetingEnabled = res.isBudgetingEnabled;
                                                            scope.isGFEServiceEnabled = res.isGFEServiceEnabled;
                                                            scope.isBarriEnabled = res.isBarriEnabled;
                                                            scope.showPayDataSheetOption = showPayDataSheetTab(policyParser, res['paySheetTypes'].paysheet_types);
                                                            scope.isSettingsTabShown = res.isSettingsTabShown;
                                                            scope.isLiveWireV2Enabled = res.isLiveWireV2Enabled;
                                                            scope.isMcDBrandReportingEnabled = res.isMcDBrandReportingEnabled;
                                                            scope.isLPMEnabled = res.isLPMEnabled;
                                                            canViewCompaasDashboard = res.canViewCompaasDashboard;
                                                            canViewRiskDashboard = res.canViewRiskDashboard;


                                                                if (scope.isBarriEnabled) {
                                                                    barriAnalyticsService.getUserBarriAllowedRoutes(brand.id, hUser.data.user.id)
                                                                        .then(function (allowedRoutes) {
                                                                            scope.allowedBarriRoutes = allowedRoutes;
                                                                            try {
                                                                                scope.$digest();
                                                                            } catch (e) {
                                                                            }
                                                                        });
                                                                } else {
                                                                    scope.allowedBarriRoutes = [];
                                                                }

                                                                scope.isLogbookEnabled = res.isLogbookEnabled;

                                                                if (scope.isLogbookEnabled) {
                                                                    LogbookAPI.getLogbookActions(brand.id).then((actions) => {
                                                                        scope.canViewLogbookEntries = actions.view_entries;
                                                                        scope.canViewTasks = actions.manage_tasks;
                                                                        scope.canViewChecklists = actions.manage_checklists;

                                                                        if (!scope.canViewTasks) {
                                                                            TeamAPI.getEmployeeLocations(brand.id).then((brands)=> {
                                                                                let logbookBrands = brands.filter((brand)=>{
                                                                                    return brand.services.includes('LOGBOOK');
                                                                                })
                                                                                scope.canViewTasks = logbookBrands.length > 0;
                                                                            })
                                                                        }
                                                                    })
                                                                }

                                                                if (res["check_payruns_tree"]) {
                                                                    scope.canManagePayRuns = !!_.findWhere(res["check_payruns_tree"].payruns_tree, {brand_id: brand.id});
                                                                }

                                                                getUnseenMessagesCount();

                                                                scope.isTeamQuestionnaireServiceEnabled = res.isTeamQuestionnaireServiceEnabled;

                                                                if (scope.isGFEServiceEnabled) {
                                                                    checkGFESettings();
                                                                }
                                                                checkRegularScheduleSettings();

                                                                try {
                                                                    scope.$digest();
                                                                } catch (e) {
                                                                }
                                                            })
                                                            .catch(function (err) {
                                                                console.error(err);
                                                            });

                                                    }, function (err) {
                                                        console.error(err)
                                                    });
                                            } else {
                                                scope.isSettingsTabShown = true;
                                                var promises = {};
                                                if (brand.services.indexOf('HARRI_CLOCK') > -1) {
                                                    promises['allow_employee_view_timesheet'] = PerformanceAggregatorAPI.getEmployeeTimesheetSettings(brand.id);
                                                }
                                                promises['commsHubExist'] = TeamScheduleService.isEmployeeBusinessHasCommsHubEnabled(brand.business_id);
                                                promises['scheduleSettings'] = TeamScheduleAPI.getEmployeeScheduleSettings(brand.id);

                                                $q.all(promises)
                                                    .then(function (res) {
                                                        scope.isTimesheetEnabled = res['allow_employee_view_timesheet'] && res['allow_employee_view_timesheet'].allow_employee_view_timesheet;
                                                        var activeBrandSettings = res.scheduleSettings['brands'].find(function (brandSettings) {
                                                            return brandSettings.id === brand.id;
                                                        });
                                                        scope.employeeConsentFlowEnabled = isEmployeeConsentFlowEnabledAtBusiness(scope.employeeBusinesses, scope.activeBusiness);
                                                        scope.employeeHaveCommsHub = res['commsHubExist'];
                                                        getUnseenMessagesCount();
                                                    })
                                                    .catch(function (err) {
                                                        console.error(err);
                                                    });
                                            }
                                        });
                                })
                                .catch(function () {
                                    scope.userData = hUser.data.user;

                                })
                        };

                        init();

                        scope.redirectToForecastsAndLabor = function () {
                            if (scope.isGastronomyLaborServiceEnabled) {
                                $state.go('appLayout.schedule.gastronomy-labor');
                            } else if (scope.isCarrolLaborServiceEnabled) {
                                $state.go('appLayout.schedule.carrol-labor')
                            } else if (scope.isWendysLaborServiceEnabled) {
                                $state.go('appLayout.schedule.wendys-labor');
                            } else if (scope.isMcDLaborServiceEnabled) {
                                $state.go('appLayout.schedule.mcd-labor');
                            } else {
                                $state.go('appLayout.schedule.forecasts-and-labor');
                            }
                        };

                        scope.showForecastsAndLaborService = function () {
                            return (
                                !scope.isDemandForecastingEnabled &&
                                scope.isEmployer &&
                                (
                                    scope.isWendysLaborServiceEnabled ||
                                    scope.isMcDLaborServiceEnabled ||
                                    scope.isGastronomyLaborServiceEnabled ||
                                    scope.isCarrolLaborServiceEnabled ||
                                    scope.isABSServiceEnabled
                                )
                            );
                        };

                        //Select a brand from the drop-down menu
                        scope.selectBrand = function (brand, dontUpdateBackend, keepMenuVisible) {

                            if (scope.activeBrand && scope.activeBrand.id == brand.id) {
                                return;
                            }

                            scope.activeBrand = brand;

                            if (!dontUpdateBackend) {
                                TeamScheduleService.setActiveBrand(brand).catch((err) => {
                                    versionManager.init(brand.id)
                                });
                            } else {
                                // load or somthing
                            }

                            closeBrandsList();

                            if (scope.isMobile && !keepMenuVisible) {
                                closeMainDropdown();
                            }
                        };

                        TeamScheduleService.onBrandChanged(function (brand, newBrand) {
                            if (hUser.getUserType() == TSUtils.MEMBER_TYPES.EMPLOYEE) {
                                init();
                                return;
                            }

                            reportsPrerequisiteService.iniReportsPrerequisite(newBrand);
                            userPermissions.getBrandPolicy(newBrand.id)
                                .then(function (policyParser) {
                                    scope.activeBrand = newBrand;
                                    scope.isUSOrPHBrand = scope.activeBrand.team_live_country_code;
                                    scope.isUKBrand = scope.activeBrand.team_live_country_code === "UK";
                                    scope.isDKBrand = scope.activeBrand.team_live_country_code === "DK";

                                    initPermissions(policyParser);

                                    var promises = {};

                                    promises['navBarPreference'] = headerItemsService.getNavBarPreference(hUser.getUserContext().brand_id, scope.activeBrand.id, headerItemsService.ACCESS_LEVELS.TEAM_LIVE);
                                    promises['isParLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.PAR_LABOR, scope.activeBrand.id);
                                    promises['isCommsHubServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ENTERPRISE_COMMUNICATION, scope.activeBrand.id);
                                    promises['isCustomReportsServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.CUSTOM_REPORTS, scope.activeBrand.id);
                                    promises['isNewsFeedService'] = userServices.isServiceEnabled(userServices.SERVICES.NEWS_FEED, scope.activeBrand.id);
                                    promises['isABSServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, scope.activeBrand.id);
                                    promises['isCarrolLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.CARROL_LABOR_MODEL, brand.id);
                                    promises['isDemandForecastingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.DEMAND_FORECASTING, scope.activeBrand.id);
                                    promises['isWendysLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.WENDYS_LABOR_MODEL, brand.id);
                                    promises['isMcDLaborServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.MCD_LABOR_MODEL, brand.id);
                                    promises['isBudgetingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.SCHEDULE_BUDGETING, scope.activeBrand.id);
                                    promises['scheduleSettings'] = TeamScheduleAPI.getScheduleSettings(brand.id);
                                    promises['isLogbookEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.LOGBOOK, brand.id);
                                    promises['isTeamQuestionnaireServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.TEAM_QUESTIONING, brand.id);
                                    promises['isLMSServiceEnabled'] = brandServices.check(brandServices.SERVICES.LMS, hUser.getEntryMode().brand_id);
                                    promises['isLMSElearningServiceEnabled'] = brandServices.check(brandServices.SERVICES.HARRI_ACADEMY, hUser.getEntryMode().brand_id);
                                    promises['isLiveWireV2Enabled'] = userServices.isServiceEnabled(userServices.SERVICES.LIVE_WIRE_V2_DASHBOARD, brand.id);
                                    promises['isMcDBrandReportingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.MCD_BRAND_REPORTING, brand.id);
                                    promises['isLPMEnabled'] = brandServices.check(brandServices.SERVICES.POS, brand.id, true);
                                    promises['canViewCompaasDashboard'] = dashboardsPrerequisiteService.canViewCompaasDashboard(brand.id);
                                    promises['canViewRiskDashboard'] = dashboardsPrerequisiteService.canViewRiskDashboard(brand.id);

                                    if (scope.hasManagePayRunsAccess) {
                                        promises['check_payruns_tree'] = PerformanceAggregatorAPI.getBrandPayrunsTree(scope.activeBrand.id);
                                    }

                                    promises['paySheetTypes'] = PerformanceAggregatorAPI.getPaysheetTypes(brand.id, true);

                                    $q.all(promises)
                                        .then(function (res) {
                                            navBarPreference = res['navBarPreference'];
                                            sortHeaderItems();
                                            scope.isParLaborServiceEnabled = res.isParLaborServiceEnabled;
                                            scope.isCommsHubServiceEnabled = res.isCommsHubServiceEnabled;
                                            scope.isCustomReportsServiceEnabled = res.isCustomReportsServiceEnabled;
                                            scope.isPostHireServiceEnabled = res.isPostHireServiceEnabled;
                                            scope.isNewsFeedService = res.isNewsFeedService;
                                            scope.isABSServiceEnabled = res.isABSServiceEnabled;
                                            scope.isCarrolLaborServiceEnabled = res.isCarrolLaborServiceEnabled;
                                            scope.isDemandForecastingEnabled = res.isDemandForecastingEnabled;
                                            scope.isWendysLaborServiceEnabled = res.isWendysLaborServiceEnabled;
                                            scope.isMcDLaborServiceEnabled = res.isMcDLaborServiceEnabled;
                                            scope.isBudgetingEnabled = res.isBudgetingEnabled;
                                            scope.approvalWorkflowEnabled = res.scheduleSettings.schedule_publish_mode === 'SUBMISSION';
                                            scope.employeeConsentFlowEnabled = res.scheduleSettings.fair_work_week_settings
                                                && res.scheduleSettings.fair_work_week_settings.penalty_general_settings
                                                && res.scheduleSettings.fair_work_week_settings.penalty_general_settings.employee_consent_flow_enabled;
                                            scope.isLogbookEnabled = res.isLogbookEnabled;
                                            scope.isLMSServiceEnabled = res.isLMSServiceEnabled;
                                            scope.isLMSElearningServiceEnabled = res.isLMSElearningServiceEnabled;
                                            scope.isLiveWireV2Enabled = res.isLiveWireV2Enabled;
                                            scope.isMcDBrandReportingEnabled = res.isMcDBrandReportingEnabled;
                                            scope.isLPMEnabled = res.isLPMEnabled;
                                            canViewCompaasDashboard = res.canViewCompaasDashboard;
                                            canViewRiskDashboard = res.canViewRiskDashboard;

                                            if (res["check_payruns_tree"]) {
                                                scope.canManagePayRuns = !!_.findWhere(res["check_payruns_tree"].payruns_tree, {brand_id: scope.activeBrand.id});
                                            }

                                            if (scope.isLMSServiceEnabled) {
                                                getAcademyRedirectionLink();
                                            }
                                            scope.showPayDataSheetOption = showPayDataSheetTab(policyParser, res['paySheetTypes'].paysheet_types);

                                            getUnseenMessagesCount();

                                            scope.isTeamQuestionnaireServiceEnabled = res.isTeamQuestionnaireServiceEnabled;

                                            if (scope.isGFEServiceEnabled) {
                                                checkGFESettings();
                                            }
                                            checkRegularScheduleSettings();

                                            setTimeout(function () {
                                                scope.$digest();
                                            }, 1);
                                        })
                                        .catch(function (err) {
                                            console.error(err);
                                        });

                                }, function (err) {
                                    console.error(err)
                                });

                            brandServices.check(brandServices.SERVICES.CANDIDATE_PRIVACY, newBrand.id, true)
                                .then(function (hide_images) {
                                    MediaUtils.setCurrentUserId(hUser.getUser().id);
                                    MediaUtils.hideUserProfileImages(hide_images);
                                })
                                .catch(function (err) {
                                    console.error(err);
                                });
                        });


                        //Handle brand data update
                        TeamScheduleService.onBrandUpdated(function (brand, newBrand) {
                            init(newBrand);
                        });

                        var checkGFESettings = function () {
                            GoodFaithEstimateAPI.getGFEBrandSettings(scope.activeBrand.id)
                                .then(function (res) {
                                    var GFEBrandSettings = res['settings'] || {};
                                    scope.incidentsTrackingSettings = GFEBrandSettings;
                                })
                                .catch(function (err){
                                    console.error(err)
                                });
                        }

                        var checkRegularScheduleSettings = function () {
                            GoodFaithEstimateAPI.getRegularScheduleSettings(scope.activeBrand.id)
                                .then(function (res) {
                                    scope.isRegularScheduleVariationsEnabled = res.regular_schedule_enabled && res.is_variations_enabled && (scope.canManageSchedule || scope.canApproveAndPublishSchedule);
                                })
                                .catch(function (err){
                                    console.error(err)
                                });
                        };

                        var closeBrandsList = function(){
                            scope.showBrandsList = false;
                            setTimeout(function () {
                                $(document).off("click.brands-dropdown");
                            },10);

                        };

                        scope.goToHarriIQRoute = function (route) {
                            $state.go("appLayout.harriSH.harri-iq", { route: route });
                        };

                        scope.onBackToHarriDashboard = async function () {
                            $state.go('appLayout.harriSH.dashboard');
                        };

                        scope.openBrandsList = function () {
                            scope.showBrandsList = true;
                            setTimeout(function () {
                                $(document).on("click.brands-dropdown", function (event) {
                                    if (scope.showBrandsList) {
                                        if ($(event.target).parents(".h-brand-list-wrapper").length === 0) {
                                            closeBrandsList();
                                            scope.$evalAsync();
                                        }
                                    }
                                });
                            },10);
                        };

                        scope.openForethoughtChatBot = () => {
                            openForethoughtAIChatbot(localize.getLang(), scope.activeBrand);
                        }

                        setTimeout(function () {
                            calculateItemsWidth();
                            element.find('#hidden-nav-container').remove();
                        }, 1);

                        $(window).on('resize', (function () {
                            scope.isMobile = $(window).width() < 1025;
                            if (!scope.isMobile && scope.isMainDropdownOpen) {
                                closeMainDropdown();
                            }
                            handleHeaderItemsPosition();
                            scope.$digest();
                        }));

                        scope.$on("$destroy", function () {
	                        scope.closeSideBar();
                            $(window).off('resize');
                            commshubService.off(commsHubMessagesCountEvent);
                            $(document).off("click.brands-dropdown");
                        });

                    }
                };
            }]);

})(TSUtils);
